/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon20Light = forwardRef('ArrowCUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.396 12.979a.5.5 0 0 1 0-.708l4.836-4.836a2.5 2.5 0 0 1 3.536 0l4.836 4.836a.5.5 0 1 1-.707.707L11.06 8.143a1.5 1.5 0 0 0-2.122 0l-4.835 4.835a.5.5 0 0 1-.708 0Z" })));
});
